// MergedChildModal.tsx
import React from "react";
import Modal from "./Modal";
import { MergedChild } from "../../models/Po";
import "./MergedChildModal.css";

interface MergedChildModalProps {
  isOpen: boolean;
  onClose: () => void;
  mergedChildren: MergedChild[];
}

const getStatusClass = (status: string) => {
  switch (status) {
    case "4":
      return "badge badge-completed";
    case "2":
      return "badge badge-in-progress";
    case "0":
      return "badge badge-not-started";
    default:
      return "badge";
  }
};

const MergedChildModal: React.FC<MergedChildModalProps> = ({
  isOpen,
  onClose,
  mergedChildren,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="80%"
      height="auto"
      contentClassName="merged-child-modal"
    >
      <h2>Merged Child Details ダミー伝票進捗</h2>
      {mergedChildren.map((mergedChild, index) => (
        <div key={index}>
          <p>
            ダミー伝票: {index + 1}: {mergedChild.merged_child_po_desc_num}
          </p>
          {mergedChild.progresses && (
            <div>
              <ul className="progress-list">
                {mergedChild.progresses?.map((progress, index) => (
                  <React.Fragment key={index}>
                    <li className={getStatusClass(String(progress.status))}>
                      {progress.mach_seq}:{progress.mach_name}
                    </li>
                    {index < (mergedChild.progresses?.length ?? 0) - 1 && (
                      <span className="arrow">&rarr;</span>
                    )}
                  </React.Fragment>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}
    </Modal>
  );
};

export default MergedChildModal;
